module.exports = __webpack_public_path__ + "static/media/RIES.45b78ba1.jpg";